export default "__VITE_ASSET__41881960__"